import { Pipe, PipeTransform } from '@angular/core';
import { InstallationStaffPluginService } from './staff.service';
@Pipe({
    name: 'stafftype',
    standalone: false
})
export class StaffTypesPipe implements PipeTransform {
  public staffTypes: any[];
  constructor(private service: InstallationStaffPluginService) {
    this.staffTypes = this.service.getStaffTypes();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.staffTypes);
  }
}
